import axion from "axios";
export default {
  token: null,
  ip: "inggepro.sytes.net:4000",
  /**
   * @return {string}
   */
  Urlbase() {
    return `http://${this.ip}/api/`;
  },
  Http() {
    return axion.create({
      baseURL: this.Urlbase(),
      headers: {
        Authorization: `Bearer ${this.token}`
      }
    });
  },
  setToken(token){
    this.token = token
  },
  getUrl() {
    return this.Urlbase;
  }
};
